import React from "react";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const MESI = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];
export const fmtYm = (ym) => `${MESI[Number(ym.slice(5, 7)) - 1]} ${ym.slice(0, 4)}`;

export const useOpConformita = (enabled = true) => {
  const { selectedStructure } = useAuth();
  const sid = selectedStructure && selectedStructure !== "all" ? selectedStructure : undefined;
  return useQuery({ enabled, queryKey: ["op-conformita", sid || "all"], retry: false, queryFn: async () => (await api.get("/operatori-conformita", { params: { structure_id: sid } })).data });
};

export default function OperatoriConformitaPanel() {
  const { data = [] } = useOpConformita();
  const list = data.filter((o) => o.manca_contratto || o.buste_ritardo.length);
  if (!list.length) return null;
  const nB = list.filter((o) => o.buste_ritardo.length).length;
  const nC = list.filter((o) => o.manca_contratto).length;
  return (
    <div className="gr-card mb-4 border-l-4 border-red-500 overflow-hidden" data-testid="op-conformita-panel">
      <div className="w-full p-4 flex items-center gap-3 bg-red-50/60">
        <AlertTriangle size={20} className="text-red-600 shrink-0" />
        <div className="flex-1 min-w-0">
          <div className="font-head font-bold text-red-800">Operatori interni da sistemare</div>
          <div className="text-xs text-red-700"><b data-testid="op-conf-n-buste">{nB}</b> con buste paga in ritardo (dopo il 15 del mese successivo) · <b data-testid="op-conf-n-contratto">{nC}</b> senza contratto di lavoro completo. Gli assunti con cooperativa sono esclusi. Trovi le etichette rosse accanto ai nomi qui sotto.</div>
        </div>
      </div>
    </div>
  );
}
